import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Entry from './utils/clientEntry';
import { AuthContextProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import './index.css';

import HomePage from './pages/HomePage';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import Cart from './pages/store/Cart';
import Store from './pages/store/Store';
import ProductDetail from './pages/store/ProductDetails';
import NotFound from './pages/NotFound';
import Contact from './pages/Contact';
import Payment from './pages/store/Payment';
import PaymentSuccess from './pages/store/PaymentSuccess';
import Profile from './pages/auth/Profile';
import ResetPassword from './pages/auth/ResetPassword';
import OrderDetails from './pages/store/OrderDetails';
import AdminDashboard from './pages/admin/AdminDashboard';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Cookies from './pages/Cookies';
import Events from './pages/events/Events';
import Event from './pages/events/Event';
import AboutUs from './pages/AboutUs';
import OrderDetailsAdmin from './pages/admin/OrderDetails';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthContextProvider>
      <CartProvider>
        <Entry />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/contatti" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/profilo" element={<Profile />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/store" element={<Store />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/orders/:orderId" element={<OrderDetailsAdmin />} />
            <Route path="/eventi" element={<Events />} />
            <Route path="/chi-siamo" element={<AboutUs />} />
            <Route path="/eventi/:eventId" element={<Event />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/product/:productId" element={<ProductDetail />} />
            <Route path="/payment/:paymentId" element={<Payment />} />
            <Route path='/payment-success' element={<PaymentSuccess />} />
            <Route path="/order/:orderId" element={<OrderDetails />} /> 
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </AuthContextProvider>
  </React.StrictMode>
);